<template>
  <ul class="tabs" @mousewheel.prevent="mousewheel" ref="tabs">
    <li :key="idx" v-for="(tab, idx) in tabs">
      <a href="#" @click.prevent="changeTab(idx)" :class="{active: tab.isActive}">{{ tab.name }}</a>
      <app-info v-if="tab.tooltip" :text="tab.tooltip"/>
    </li>
  </ul>
</template>

<script>
import AppInfo from "@/components/AppInfo";

export default {
  name: 'Tabs',
  components: {AppInfo},
  props: {
    tabs: [Array, Object]
  },
  methods: {
    changeTab(idx) {
      this.$emit('changeTab', idx)
    },
    mousewheel(e) {
      this.$refs.tabs.scrollLeft -= (e.deltaY * 30);
    }
  }
}
</script>

<style scoped lang="scss">

.tabs {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 20px -5px;
  margin-bottom: 10px;
  flex-wrap: wrap;

  li {
    margin-bottom: 10px;
    padding: 0 5px;
    display: flex;
    align-items: center;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: nowrap;
      white-space: nowrap;
      word-wrap: initial;
      text-decoration: none;
      padding: 13px 25px;
      border-radius: 200px;
      background-color: #fff;
      font-weight: 600;
      font-size: 16px;
      color: #808080;
      font-family: "Open Sans", sans-serif;
      margin-right: 4px;

      &.active {
        color: #383838;
        background-color: #DBBFA7;

        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

@media(max-width: 600px) {
  .tabs {
    overflow-y: auto;
    flex-wrap: nowrap;
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .tabs::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  .tabs {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }
}
</style>
